import { DECLINE_REASON_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const DeclineReasonService = {
  getAll: (params: any) => requests.get(`${DECLINE_REASON_URL}`, params),
  create: (params: any) => requests.post(`${DECLINE_REASON_URL}`, params),
  getSingle: (id: number) => requests.get(`${DECLINE_REASON_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${DECLINE_REASON_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${DECLINE_REASON_URL}/${id}`),
};